import { TFunction } from 'react-i18next';
import { BulkAction, MeasureUnitCode } from '../helpers';
import { IStoreItem } from '@/models/products.model';

export const getActiveOptions = (t: TFunction) => [
  { value: '1', label: t('products_list_active') },
  { value: '0', label: t('products_list_inactive') },
];

export const getBulkActionOptions = (t: TFunction) => [
  { value: BulkAction.DELETE, label: t('products_list_delete_products') },
  { value: BulkAction.HIDE, label: t('products_list_hide_products') },
];

export const getStoresOptions = (partners: IStoreItem[]) =>
  partners
    ?.filter((partner: IStoreItem) => partner.title?.trim())
    .map((partner: IStoreItem) => ({ label: partner.title, value: partner.id }));

export const getUnitsOptions = (t: TFunction) => {
  return [
    { value: MeasureUnitCode.PIECE, label: `${t('product_unit_name_piece')} (${t('product_unit_short_name_piece')})` },
    { value: MeasureUnitCode.GRAM, label: `${t('product_unit_name_gram')} (${t('product_unit_short_name_gram')})` },
    {
      value: MeasureUnitCode.KILOGRAM,
      label: `${t('product_unit_name_kilogram')} (${t('product_unit_short_name_kilogram')})`,
    },
    { value: MeasureUnitCode.TON, label: `${t('product_unit_name_ton')} (${t('product_unit_short_name_ton')})` },
    { value: MeasureUnitCode.LITER, label: `${t('product_unit_name_liter')} (${t('product_unit_short_name_liter')})` },
    { value: MeasureUnitCode.METER, label: `${t('product_unit_name_meter')} (${t('product_unit_short_name_meter')})` },
    {
      value: MeasureUnitCode.LINEAR_METER,
      label: `${t('product_unit_name_linear_meter')} (${t('product_unit_short_name_linear_meter')})`,
    },
    {
      value: MeasureUnitCode.SQUARE_METER,
      label: `${t('product_unit_name_square_meter')} (${t('product_unit_short_name_square_meter')})`,
    },
    {
      value: MeasureUnitCode.CUBIC_METER,
      label: `${t('product_unit_name_cubic_meter')} (${t('product_unit_short_name_cubic_meter')})`,
    },
    {
      value: MeasureUnitCode.PACKAGE,
      label: `${t('product_unit_name_package')} (${t('product_unit_short_name_package')})`,
    },
    { value: MeasureUnitCode.SET, label: `${t('product_unit_name_set')} (${t('product_unit_short_name_set')})` },
    { value: MeasureUnitCode.PAIR, label: `${t('product_unit_name_pair')} (${t('product_unit_short_name_pair')})` },
    {
      value: MeasureUnitCode.SERVICE,
      label: `${t('product_unit_name_service')} (${t('product_unit_short_name_service')})`,
    },
    { value: MeasureUnitCode.BAY, label: `${t('product_unit_name_bay')} (${t('product_unit_short_name_bay')})` },
    { value: MeasureUnitCode.PACK, label: `${t('product_unit_name_pack')} (${t('product_unit_short_name_pack')})` },
    { value: MeasureUnitCode.REEL, label: `${t('product_unit_name_reel')} (${t('product_unit_short_name_reel')})` },
  ];
};
